<template>
    <container :class="{
      'pa-0': $vuetify.breakpoint.smAndDown,
      'px-5 py-5': $vuetify.breakpoint.mdAndUp,
    }">

     <v-layout row wrap mx-5 md12>
				<v-flex xs12 justify-center>
					<h3 style="color: #1f97b9; font-size: 30px;">El Blog de DuoAPP</h3>
				</v-flex>
    </v-layout>

    <br>
     <v-layout v-if="!mobile" row wrap sm12 lg12 justify-center> 
        <v-flex xs12 sm10> 
            <v-carousel hide-delimiters hide-controls>
                 <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
                :src="item.src"
                >
                </v-carousel-item>
            </v-carousel>
        </v-flex>
    </v-layout>
<!--mobile-->
    <v-layout v-if="mobile" row wrap sm12 lg12 justify-center> 
        <v-flex xs12 sm10> 
          <v-img :src='require("../../../assets/static/img/img-Blog/Post-4.webp")' alt="imagen del ultimo post"></v-img>    
        </v-flex>
    </v-layout>

  <br>
<v-layout row wrap mx-5 mt-5 pa-3 md12>
			<v-layout row wrap justify-centermx-5 mt-5>
				<v-flex xs12 justify-center>
					<h3 style="color: #1f97b9; font-size: 30px;">Nuestros articulos:</h3>
				</v-flex>
			</v-layout>
</v-layout> 

      <v-layout col row wrap ma-5 xs12 md12 justify-space-around>
        
        <v-flex class="caja-articulo" xs12 sm3 justify-center>
                  <v-img :src='require("../../../assets/static/img/img-Blog/Post-4.webp")' alt="imagen del ultimo post"></v-img>
                  <br>
                  <h2>10 tips para mudanzas HUH</h2> 
                  <br>
                  <h3>Hagalo Usted Mismo</h3>
                  <br> 
                  <v-layout justify-center>
                  <v-btn @click="avanzarA4()" style="background-color: #1f97b9; color: #ffffff;">Leer</v-btn>  
                </v-layout>  
              </v-flex>

              <v-flex class="caja-articulo" xs12 sm3 justify-center>
                  <v-img :src='require("../../../assets/static/img/img-Blog/Post-3.webp")' alt="imagen del ultimo post"></v-img>
                  <br>
                  <h2>Las 3 R de la ropa</h2> 
                  <br>
                  <br>
                  <h3>En una mudanza</h3>
                  <br> 
                  <v-layout justify-center>
                  <v-btn @click="avanzarA3()" style="background-color: #1f97b9; color: #ffffff;">Leer</v-btn>  
                </v-layout>  
              </v-flex>


              <v-flex class="caja-articulo" xs12 sm3 align-self-center>
                  <v-img :src='require("../../../assets/static/img/img-Blog/Post-2.webp")' alt="imagen del segundo post" ></v-img>
                  <br>
                  <h2>5 tips para la planificacion</h2> 
                  <br>
                  <h3>De tu mudanza</h3>
                  <br> 
                  <v-layout justify-center>
                    <v-btn @click="avanzarA2()" style="background-color: #1f97b9; color: #ffffff;">Leer</v-btn>
                  </v-layout> 
              </v-flex>
              
              <v-layout col row wrap ma-5 xs12 md12 justify-left>

                <v-flex class="caja-articulo" xs12 sm3 align-self-center>
                    <v-img :src='require("../../../assets/static/img/img-Blog/Post-1.webp")' alt="imagen del primer post"></v-img>
                    <br>
                    <h2>Salvoconductos de mudanzas</h2> 
                    <br>
                    <h3>En simple</h3>
                    <br> 
                    <v-layout justify-center>
                      <v-btn @click="avanzarA1()" style="background-color: #1f97b9; color: #ffffff;">Leer</v-btn>
                    </v-layout> 
                </v-flex>

              </v-layout>

      </v-layout>             
    </container>      
</template>

<script>
import { EventBus } from "../../../events.js";
import resize from 'vue-resize-directive';
export default {
    directives: {
      resize
    },
    data () {
      return {
        windowWidth: 0,
        mobile: false,
        items: [
          {
            
            src: require("../../../assets/static/img/img-Blog/Post-4.webp")
          },
          {
            src: require("../../../assets/static/img/img-Blog/Post-3.webp")
          },
          {
            src: require("../../../assets/static/img/img-Blog/Post-2.webp")
          }
        ]
      }
    },
    methods:{
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth
      	this.mobile = false
        if( this.windowWidth < 762 ){
        	this.mobile = true
        }
      },
      isMobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
        } else {
        return false
        }
      },

      avanzarA1(){

      EventBus.$emit('BlogHome->Articulo1', 2);
      },

      avanzarA2(){

      EventBus.$emit('BlogHome->Articulo2', 3);
      },

      avanzarA3(){

      EventBus.$emit('BlogHome->Articulo3', 4);
      },

      avanzarA4(){

      EventBus.$emit('BlogHome->Articulo4', 5);
      },

      //retroceder(){
        //EventBus.$emit('Retroceder', 2);
      //}

    },
    mounted(){
        window.scrollTo(0, 0)
        this.$nextTick(function() {
	      window.addEventListener('resize', this.getWindowWidth)
	      this.getWindowWidth()
	    })
    }
}
</script>

